<div [ngClass]="{'global-notifications': (notificationsCount$|async) > 0 }">
    <div class="banner-notifications-container" bannerNotificationsContainer></div>
</div>
